import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import BuyCredits from "@/pages/BuyCredits";
import About from "@/pages/About";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import RefundPolicy from "@/pages/RefundPolicy";
import Contact from "@/pages/Contact";
import CreateVideo from "@/pages/CreateVideo";
import VideoJualan from "@/pages/VideoJualan";
import ShortDrama from "@/pages/ShortDrama";
import VideoHistory from "@/pages/VideoHistory";
import MyAvatar from "@/pages/MyAvatar";
import Settings from "@/pages/Settings";
import Credits from "@/pages/Credits";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { AdminRoute } from "@/components/AdminRoute";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminTestVideo from "@/pages/AdminTestVideo";
import TrackingRuntime from "@/components/TrackingRuntime";
import Affiliate from "@/pages/Affiliate";
import AdminAffiliate from "@/pages/AdminAffiliate";
import AdminBusinessSettings from "@/pages/AdminBusinessSettings";
import AdminFinance from "@/pages/AdminFinance";
import ModelHub from "@/pages/ModelHub";
import NotificationSettings from "@/pages/NotificationSettings";
import ChatAI from "@/pages/ChatAI";
import Help from "@/pages/Help";
import MyTransactions from "@/pages/MyTransactions";
import AdminModelControl from "@/pages/AdminModelControl";
import AdminRefunds from "@/pages/AdminRefunds";

const Protected = ({ children }) => (
  <ProtectedRoute>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <TrackingRuntime />
          <Routes>
            <Route path="/masuk" element={<Login />} />
            <Route path="/daftar" element={<Register />} />
            <Route path="/" element={<Landing />} />
            <Route path="/tentang" element={<About />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/syarat-ketentuan" element={<Terms />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/kontak" element={<Contact />} />
            <Route path="/bantuan" element={<Help />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/beli-kredit" element={<Protected><BuyCredits /></Protected>} />
            <Route path="/buat-video" element={<Protected><CreateVideo /></Protected>} />
            <Route path="/video-jualan" element={<Protected><VideoJualan /></Protected>} />
            <Route path="/shortdrama" element={<Protected><ShortDrama /></Protected>} />
            <Route path="/model-hub" element={<Protected><ModelHub /></Protected>} />
            <Route path="/avatar-saya" element={<Protected><MyAvatar /></Protected>} />
            <Route path="/riwayat" element={<Protected><VideoHistory /></Protected>} />
            <Route path="/pengaturan" element={<Protected><Settings /></Protected>} />
            <Route path="/chat" element={<Protected><ChatAI /></Protected>} />
            <Route path="/notifikasi" element={<Protected><NotificationSettings /></Protected>} />
            <Route path="/kredit" element={<Protected><Credits /></Protected>} />
            <Route path="/transaksi" element={<Protected><MyTransactions /></Protected>} />
            <Route path="/affiliate" element={<Protected><Affiliate /></Protected>} />
            <Route path="/admin/masuk" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
            <Route path="/admin/test-video" element={<AdminRoute><AdminTestVideo /></AdminRoute>} />
            <Route path="/admin/affiliate" element={<AdminRoute><AdminAffiliate /></AdminRoute>} />
            <Route path="/admin/business-settings" element={<AdminRoute><AdminBusinessSettings /></AdminRoute>} />
            <Route path="/admin/keuangan" element={<AdminRoute><AdminFinance /></AdminRoute>} />
            <Route path="/admin/model-control" element={<AdminRoute><AdminModelControl /></AdminRoute>} />
            <Route path="/admin/refund" element={<AdminRoute><AdminRefunds /></AdminRoute>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
